import { useMemo } from 'react'
import { useAppSelector } from '@/store/hooks'
import { moderationApi } from './moderationApi'
import { useCourseModeration } from './useCourseModeration'
import { useFreshSince } from './lib/useFreshSince'

/**
 * Состояние модерации, полученное ПОСЛЕ монтирования потребителя. Кеш `/moderation`
 * живёт ~60 с без подписки: открыв редактор снова, `useCourseModeration` сразу отдал бы
 * прошлый `draftId`, а черновик за это время мог появиться (MCP, вторая вкладка) — и
 * редактор прочёл бы живую версию поверх черновика. Механика «свежее с монтирования» —
 * `useFreshSince` (общая со статьёй); свежий ответ ставит `ModerationPoller`
 * (`refetchOnMountOrArgChange`). Подписки здесь нет: запрос ведёт единственный поллер.
 */
export const useFreshCourseModeration = (
  courseId: number,
): ReturnType<typeof useCourseModeration> => {
  const moderation = useCourseModeration(courseId)
  const select = useMemo(
    () => moderationApi.endpoints.getCourseModeration.select(courseId),
    [courseId],
  )
  const isFresh = useFreshSince(courseId, useAppSelector(select))
  return { ...moderation, state: isFresh ? moderation.state : undefined }
}
